module.exports = __webpack_public_path__ + "img/ChatsworthSticks.23589000.jpg";